import { render, staticRenderFns } from "./shop-type-detail.vue?vue&type=template&id=a420c48c&"
import script from "./shop-type-detail.vue?vue&type=script&lang=js&"
export * from "./shop-type-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports